export default __webpack_public_path__ + "static/media/acms-accounting.f1609da1.svg";